import { PropaneSharp } from '@mui/icons-material';

import useUser from '../../hooks/useUser';
import AppDashboard from '../AppDashboard';
import AdminHomeScreen from '../../components/admin/AdminHomeScreen';

const AdminHomePage = props => {
  const user = useUser();
  const childProps = {
    ...props,
    user,
    loading: !useUser,
  };
  return (
    <AppDashboard loading={childProps.loading} hideBack={true}>
      <AdminHomeScreen {...childProps} />
    </AppDashboard>
  );
}

export default AdminHomePage;